<template>
    <v-data-table
        :headers="headers"
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="paginationData"
        :total-items="paginationData.totalItems"
        :rows-per-page-text="$f.tc('rowsPerPage')"
        :class="{'data-table-mobile': $utils.isMobile()}"
        :no-data-text="$t('noDataAvailable') | capitalize"
        :hide-headers="$utils.isMobile()"
        :hide-actions="hideActions"
        :custom-sort="customSort"
    >
        <template v-slot:items="props">
            <tr v-if="$utils.isMobile()" @click="onRowClick(props.item)" :class="rowClass">
                <td :colspan="headers.length" class="pa-0">
                    <div class="dtm-cell mb-3 pa-2">
                        <div class="dtm-row" v-for="header in headers" :key="header.text">
                            <div class="dtm-header">{{ header.text }}</div>
                            <div>
                                <template v-if="header.type === 'custom'">
                                    <slot :name="header.id || header.value" :item="props.item"></slot>
                                </template>
                                <template v-else>
                                    {{ getValue(header, props.item, props.index) }}
                                </template>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-else
                @click="onRowClick(props.item)"
                :class="rowClass"
                :style="{cursor: $listeners['row-click'] ? 'pointer' : 'normal'}"
            >
                <td
                    v-for="header in headers"
                    :key="header.text"
                    :class="getClass(header, props.item)"
                    :style="getStyle(header, props.item)"
                >
                    <template v-if="header.type === 'custom'">
                        <slot :name="header.id || header.value" :item="props.item"></slot>
                    </template>
                    <template v-else>
                        {{ getValue(header, props.item, props.index) }}
                    </template>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>
<script>

export default {
    name: 'SimpleDataTable',
    props: {
        headers: Array,
        items: Array,
        pagination: Object,
        rowClass: {
            type: String,
            default: ''
        },
        customSort: Function,
        rowsPerPageItems: {
            type: Array,
            default: () => [5, 10, 20, 50]
        },
        hideActions: Boolean
    },
    data () {
        let paginationData = this.pagination ? { ...this.pagination } : {}
        if (!paginationData.page) {
            paginationData.page = 1
        }
        if (!paginationData.rowsPerPage) {
            paginationData.rowsPerPage = this.rowsPerPageItems[0]
        }
        return {
            paginationData: paginationData,
            $utils: this.$utils
        }
    },
    methods: {
        onRowClick (rowData) {
            this.$emit('row-click', rowData)
        },
        getValue (header, item, index) {
            return typeof header.$value === 'function' ? header.$value(item, index) : item[header.value]
        },
        getClass (header, item) {
            let className = header.class ? header.class : ''
            className += header.$class ? ' ' + header.$class(item) : ''
            return className
        },
        getStyle (header, item) {
            let style = header.style ? header.style : ''
            style += header.$style ? header.$style(item) : ''
            return style
        }
    },
    watch: {
        pagination (val) {
            for (let i in val) {
                this.paginationData[i] = val[i]
            }
        },
        paginationData (val) {
            this.$emit('update:pagination', val)
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .v-datatable__actions__select .v-select {
        margin: 0 0 0 10px !important;
    }

    .v-input__slot {
        margin-bottom: 0 !important;
        padding: 0 10px !important;
        border-radius: 5px !important;
        border: 1px solid #D9D9D9;
        font-size: 14px !important;
        height: 30px;
    }

    .v-input__slot:before, .v-input__slot:after {
        border: none !important;
    }

    .v-datatable__actions__pagination, .v-datatable__actions__select {
        font-size: 14px !important;
    }

    th {
        background: #E4EDFA;
        font-size: 14px !important;
        font-weight: bold !important;
        color: #12274F !important;
    }

    table.v-table thead tr:not(.v-datatable__progress) {
        height: 46px !important;
    }

    thead {
        tr {
            border: 1px solid #96add0 !important;
            border-bottom: none !important;
            border-left: none !important;
            border-right: none !important;
        }
    }

    .v-datatable:has(.v-datatable__actions), .v-table__overflow {
        border: 1px solid #96add0 !important;
        border-top: none !important;
    }

    .v-datatable__actions__select .v-select {
        overflow: visible !important;
    }
}
</style>
